
import { FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { TextStyleOptions } from "../../../../setting/text/IText";
import { DebugPerformanceType } from "./DebugPerformance";
import { ArrayHelper } from "../../../../utils/ArrayHelper";

export class DebugPerformanceRow extends PIXI.Container {

    private textName:PIXI.Text;
    private textValue:PIXI.Text;

    private keyType:string;
    private bg:PIXI.Graphics;

    private timePoints:number[] = [];
    private pointIndex:number = 0;

    private lastTime:number = -1;

    private topCont:PIXI.Container;

    private DEFAULT_TEXT_STYLE:TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 10,
        dropShadowDistance: 2,
        fontFamily : "Helvetica",
        fontWeight : FontWeight.BOLD,
        fontSize: 22,
        align:"left",
        fill: [
            "white",
        ]
    };

    private rowID:number;
    public get ID():number {
        return this.rowID;
    }

    constructor(key:string){
        super();
        this.keyType = key;

        this.CreateOrUpdate();
    }

    public setRowID(value:number):void{
        this.rowID = value;
        if(this.bg){
            this.bg.tint = value % 2 ? 0x033030 : 0x220033, 0.75;
        }
    }

    public CreateOrUpdate():void {
        if(!this.textName){
            this.bg = this.createGraphic(480,40);
            this.textName = this.addChild(new PIXI.Text(this.keyType + ":", this.DEFAULT_TEXT_STYLE));
            this.textValue = this.addChild(new PIXI.Text(this.keyType + ":", this.DEFAULT_TEXT_STYLE));
            this.textValue.x = 300;
        }
        // this.identifyValue();
        this.updateGraphicLayout();
    }

    private updateGraphicLayout():void{
        this.bg.height *= this.height / this.bg.height;
    }
    public reset(): void {
        this.timePoints = [];
        this.lastTime = -1;
    }

    public onUpdate(currTime:number): void {
        switch(this.keyType){
            case DebugPerformanceType.FPS:
            case DebugPerformanceType.AVERAGE_FPS:
                this.updateFPS(this.keyType == DebugPerformanceType.AVERAGE_FPS,currTime);
                break;
            case DebugPerformanceType.NR_OBJECTS:
            case DebugPerformanceType.NR_MASKS:
            case DebugPerformanceType.NR_RENDERED_OBJECTS:
                this.pixiObjCheck();
                break;
            default:
                break
        }
    }

    private pixiObjCheck():void{

        if(!this.topCont) this.topCont = this.fetchSuperContainer(this);

        let amm:number = 0;
        switch(this.keyType){
            case DebugPerformanceType.NR_OBJECTS:
                this.textValue.text = this.diveCheck(this.topCont,amm,
                    (c) => { return true }, this.checkRenderItems
                ).toString();
                break;
            case DebugPerformanceType.NR_MASKS:
                this.textValue.text = this.diveCheck(this.topCont,amm,
                    this.isPIXIRendered, (c) => { return !!c.mask }
                ).toString();
                break;
            case DebugPerformanceType.NR_RENDERED_OBJECTS:
                this.textValue.text = this.diveCheck(this.topCont,amm,
                    this.isPIXIRendered, this.checkRenderItems
                ).toString();
                break;
            default:
                break
        }
    }

    private isPIXIRendered(t:PIXI.DisplayObject):boolean { return !!t.alpha && t.visible}

    private diveCheck(t:PIXI.Container, amm:number, check:(cont:PIXI.DisplayObject) => boolean,count:(cont:PIXI.DisplayObject) => boolean):number {
        if(check(t) && t.name != "TestTool"){
            if(count(t)) amm++;
            if(t instanceof PIXI.Container){
                for(let i:number = 0; i < t.children.length; i++){
                    if(t.children[i] instanceof PIXI.Container){
                        amm = this.diveCheck(t.children[i]! as PIXI.Container, amm, check, count);
                    }
                }
            }
        }
        return amm;
    }

    private checkRenderItems(t:PIXI.DisplayObject):boolean{
        return (t instanceof PIXI.Mesh) || (t instanceof PIXI.Sprite) || (t instanceof PIXI.Graphics) || (t instanceof PIXI.BitmapText) || (t instanceof PIXI.ParticleContainer)
    }

    private fetchSuperContainer(t:PIXI.Container):PIXI.Container{
        return t.parent && t.name != "Stage" ?  (this.fetchSuperContainer(t.parent)) : t;
    }

    private updateFPS(isAverage:boolean,time:number):void{
        if(this.lastTime != -1) {
            const deltaTime:number = time - this.lastTime;
            this.lastTime = time;
            if(deltaTime <= (1/66)*1000) return; // removes values quicker than 66 fps
            if(isAverage){
                this.timePoints[this.pointIndex] = deltaTime;
                this.pointIndex++;
                if(this.pointIndex > 100) this.pointIndex = 0;
                const val:number = ArrayHelper.arraySum(this.timePoints)/this.timePoints.length;
                this.textValue.text = (1000 / val ).toPrecision(2);
            }else{
                this.textValue.text = (1000 / deltaTime ).toPrecision(2);
            }
        }
        this.lastTime = time;
    }

    private createGraphic(sizeX:number = 500,sizeY?:number): PIXI.Graphics {
        if(!sizeY) sizeY = sizeX;
        const gfx:PIXI.Graphics = this.addChild(new PIXI.Graphics());
        gfx.clear();
        gfx.beginFill(0xFFFFFF, 1);
        gfx.drawRect(0,0, sizeX, sizeY);
        gfx.endFill();
        return gfx;
    }
}